import * as yup from 'yup';

export const editAICriteriaSetValidation = yup.object({
  client: yup.mixed().test('required', 'Client is required', (v: any) => !!v?.id),
  scopeable: yup.mixed().nullable().test('required', 'Group is required', (v: any) => !!v?.id),
  categories: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        name: yup.string().required('Category name is required'),
        color: yup.string().required('Category color is required'),
        order: yup.number().required(),
      })
    )
    .min(1, 'At least one category is required'),
});
